// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "可编程控制器",
      "tec": "贾晓梅",
      "week": "1-6,8-10,13-14,17-18周",
      "add": "402国教"
    },
    {
      "sub": "热工测量与仪表",
      "tec": "于宏涛",
      "week": "1-6,8-10,13-14,17周",
      "add": "402国教"
    },
    {
      "sub": "电气控制技术",
      "tec": "王刚",
      "week": "1-6周",
      "add": "教学楼C座302教务"
    },
    0,
    0
  ],
  "2": [
    [
      {
        "sub": "综合英语3",
        "tec": "林铁",
        "week": "1-2,5-8,12-18周",
        "add": "动1"
      },
      {
        "sub": "108国教",
        "tec": "张楹",
        "week": "1-2,5-8,12-18周",
        "add": "动1"
      },
      {
        "sub": "106国教",
        "tec": "张琳",
        "week": "1-2,5-8,12-18周",
        "add": "动1"
      },
      {
        "sub": "103国教",
        "tec": "宋孚红",
        "week": "1-2,5-8,12-18周",
        "add": "动1"
      }
    ],
    {
      "sub": "电力电子技术",
      "tec": "李嘉欣闫鸿魁李东明",
      "week": "1-6,8-10,13-14,17-18周",
      "add": "319国教"
    },
    {
      "sub": "习近平新时代中国特色社会主义思想概论",
      "tec": "吴世鑫",
      "week": "1-2,5-6,8-9,13-14周",
      "add": "教学楼C座114教务"
    },
    {
      "sub": "就业创业指导",
      "tec": "孔瀚",
      "week": "1-2,5-6,8周",
      "add": "教学楼C座113教务"
    },
    0
  ],
  "3": [
    {
      "sub": "电气控制技术",
      "tec": "王刚",
      "week": "1-6周",
      "add": "402国教"
    },
    [
      {
        "sub": "交际口语3",
        "tec": "外教9",
        "week": "1-2,5-8,12-18周",
        "add": "动2"
      },
      {
        "sub": "103国教",
        "tec": "外教6",
        "week": "1-2,5-8,12-18周",
        "add": "动2"
      },
      {
        "sub": "104国教",
        "tec": "外教8",
        "week": "1-2,5-8,12-18周",
        "add": "动2"
      },
      {
        "sub": "106国教",
        "tec": "外教7",
        "week": "1-2,5-8,12-18周",
        "add": "动2"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "电气控制技术",
      "tec": "王刚",
      "week": "1-6周",
      "add": "502国教"
    },
    [
      {
        "sub": "综合英语3",
        "tec": "林铁",
        "week": "1-2,5-8,12-18周",
        "add": "动4"
      },
      {
        "sub": "108国教",
        "tec": "张楹",
        "week": "1-2,5-8,12-18周",
        "add": "动4"
      },
      {
        "sub": "106国教",
        "tec": "宋孚红",
        "week": "1-2,5-8,12-18周",
        "add": "动4"
      },
      {
        "sub": "104国教",
        "tec": "张琳",
        "week": "1-2,5-8,12-18周",
        "add": "动4"
      }
    ],
    {
      "sub": "可编程控制器",
      "tec": "贾晓梅",
      "week": "1-6,8-10,13-14,17-18周",
      "add": "教学楼C座302教务"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "习近平新时代中国特色社会主义思想概论",
      "tec": "吴世鑫",
      "week": "1-2,5-6,8-9,13-14周",
      "add": "教学楼A座322电力"
    },
    {
      "sub": "电力电子技术",
      "tec": "李嘉欣闫鸿魁李东明",
      "week": "1-6,8-10,13-14,17-18周",
      "add": "教学楼C座303教务"
    },
    {
      "sub": "热工测量与仪表",
      "tec": "于宏涛",
      "week": "2,4,6,8,10,14周",
      "add": "教学楼C座303教务"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
